import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-583a8864"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Agencies List")
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_3 = { class: "w-100 bg-white p-5" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "text-capitalize" }
const _hoisted_6 = { style: {"padding-left":"0.5em"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_StatusIndicator = _resolveComponent("StatusIndicator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "agency-container" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("Found " + _toDisplayString(_ctx.table.total) + " " + _toDisplayString(_ctx.agencyText), 1)
    ]),
    default: _withCtx(() => [
      (!_ctx.table.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                row: "5"
              })
            ])
          ]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            "table-data": _ctx.table.items,
            "table-header": _ctx.tableHeaders,
            "enable-items-per-page-dropdown": true,
            loading: _ctx.table.loading,
            "onClick:row": _ctx.viewAgent,
            "rows-per-page": 10,
            "row-class": "table-hover"
          }, {
            "cell-business_name": _withCtx(({ row: item }) => [
              _createVNode(_component_router_link, {
                to: { name: 'view-agency', params: { agent_id: item.id } },
                style: {"color":"inherit"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.business_name), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_StatusIndicator, {
                        modelValue: _ctx.getStatus(item).value
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            "cell-status": _withCtx(({ row: item }) => [
              _createVNode(_component_Chip, {
                type: _ctx.getStatus(item).type,
                text: _ctx.getStatus(item).text
              }, null, 8, ["type", "text"])
            ]),
            "cell-signup_date": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.signup_date, 'aus')), 1)
            ]),
            "cell-user_count": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.user_count), 1)
            ]),
            "cell-review_report_count": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.review_report_count), 1)
            ]),
            "cell-reference_request_count": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.reference_request_count), 1)
            ]),
            "cell-referred_tenants_count": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.referred_tenants_count), 1)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "onClick:row"]))
    ]),
    _: 1
  }))
}